import ProductAvailability from '~/themes/base/components/product/ProductAvailability'

export default {
  extends: ProductAvailability,
  computed: {
    isAvailable() {
      return this.product.availability.isAvailable && this.product.availability.stock > 0
    },
    text() {
      return this.isAvailable ? this.$t('ProductAvailability.inStock') : this.$t('ProductAvailability.order')
    },
  },
}
